import { apiEndpoint } from '@/config';
import { useRouter } from '@/i18n/routing';
import { useAuth } from '@/lib/auth/use-auth';
import { fetcher } from '@/lib/swr';
import {
  ApiErrorResponse,
  ApiSuccessResponse,
  ClassResourceViewModel,
} from '@hidayahlab/academy-suite-corelib';
import useSWR from 'swr';

export function useGetClassResources(courseId: number, lessonId?: number) {
  const { token } = useAuth();
  const router = useRouter();

  const shouldFetch = !!token && !!courseId && !!lessonId;
  const apiUrl = shouldFetch
    ? `${apiEndpoint}/class-resources?lessonId=${lessonId}&courseId=${courseId}`
    : null;

  const { data, error, isLoading } = useSWR<
    ApiSuccessResponse<ClassResourceViewModel[]>,
    ApiErrorResponse
  >(apiUrl, (url: string) => fetcher(url, token));

  if (data?.statusCode === 401) {
    router.push('/logout');
  }

  return {
    data: data?.data,
    isLoading,
    isError: error,
  };
}

export function useGetClassResourcesForFreeLesson(
  courseId: number,
  lessonId?: number,
) {
  const apiUrl = `${apiEndpoint}/class-resources/free?lessonId=${lessonId}&courseId=${courseId}`;

  const { data, error, isLoading } = useSWR<
    ApiSuccessResponse<ClassResourceViewModel[]>,
    ApiErrorResponse
  >(apiUrl, (url: string) => fetcher(url));

  return {
    data: data?.data,
    isLoading,
    isError: error,
  };
}
